module.exports = __webpack_public_path__ + "static/release-e9d35676586e9f503569b013308daf4f.png";